import constants from "../assets/constants/constants";

export const translateZammadState = (state) => {
    if (!state) return state;

    const translation = constants.zammadStates.find((item) => item.value.toLowerCase() === state.toLowerCase());

    return translation ? translation.label : state;
};

export const getZammadStateVariant = (state) => {
    if (!state) return "default";

    const stateKey = state.toLowerCase();

    switch (stateKey) {
        case "new":
        case "nouveau":
            return "info";
        case "open":
        case "ouvert":
            return "warning";
        case "pending reminder":
        case "pending close":
        case "en attente de rappel":
        case "en attente de fermeture":
            return "secondary";
        case "closed":
        case "merged":
        case "fait":
        case "fermé":
        case "fusionné":
            return "success";
        default:
            return "default";
    }
};
